import React from 'react';
import { assetUrl } from '../../lib/api';

export const PageHero = ({ title, subtitle, image }) => (
  <section
    className="relative w-full min-h-[280px] sm:min-h-[340px] flex items-center bg-[#26247B]"
    style={
      image
        ? { backgroundImage: `url(${assetUrl(image)})`, backgroundSize: 'cover', backgroundPosition: 'center' }
        : undefined
    }
  >
    <div className="absolute inset-0 hero-overlay" />
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-16 w-full text-center">
      <h1 data-testid="page-hero-title" className="text-white font-extrabold text-3xl sm:text-5xl tracking-tight">{title}</h1>
      {subtitle && <p className="mt-4 text-white/95 text-base sm:text-lg font-medium leading-7 max-w-3xl mx-auto">{subtitle}</p>}
    </div>
  </section>
);
